class HeroSlider {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll(".hero-slide");
    this.prevButton = container.querySelector(".hero-slider__nav--prev");
    this.nextButton = container.querySelector(".hero-slider__nav--next");
    this.currentSlide = 0;
    this.autoPlayInterval = null;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    this.prevButton.addEventListener("click", () => {
      this.navigate(-1);
      this.resetAutoPlay();
    });

    this.nextButton.addEventListener("click", () => {
      this.navigate(1);
      this.resetAutoPlay();
    });

    // Auto advance slides
    this.startAutoPlay();
  }

  navigate(direction) {
    this.slides[this.currentSlide].classList.remove("active");
    this.currentSlide =
      (this.currentSlide + direction + this.slides.length) % this.slides.length;
    this.slides[this.currentSlide].classList.add("active");
  }

  resetAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
    this.startAutoPlay();
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => this.navigate(1), 3000);
  }
}

class VehicleFinder {
  constructor() {
    this.yearSelect = document.getElementById("yearSelect");
    this.makeSelect = document.getElementById("makeSelect");
    this.modelSelect = document.getElementById("modelSelect");

    this.init();
  }

  init() {
    this.yearSelect.addEventListener("change", () => {
      if (this.yearSelect.value) {
        this.makeSelect.disabled = false;
        // Here you would typically fetch makes for the selected year
        this.populateMakes();
      } else {
        this.makeSelect.disabled = true;
        this.modelSelect.disabled = true;
      }
    });

    this.makeSelect.addEventListener("change", () => {
      if (this.makeSelect.value) {
        this.modelSelect.disabled = false;
        // Here you would typically fetch models for the selected make
        this.populateModels();
      } else {
        this.modelSelect.disabled = true;
      }
    });
  }

  populateMakes() {
    // This would typically be an API call to get makes for the selected year
    // For demo purposes, we'll add some static options
    const makes = ["Audi", "BMW", "Mercedes", "Porsche", "Lamborghini"];
    this.makeSelect.innerHTML = '<option value="">Select Make</option>';
    makes.forEach((make) => {
      const option = document.createElement("option");
      option.value = make.toLowerCase();
      option.textContent = make;
      this.makeSelect.appendChild(option);
    });
  }

  populateModels() {
    // This would typically be an API call to get models for the selected make
    // For demo purposes, we'll add some static options
    const models = ["Model 1", "Model 2", "Model 3", "Model 4"];
    this.modelSelect.innerHTML = '<option value="">Select Model</option>';
    models.forEach((model) => {
      const option = document.createElement("option");
      option.value = model.toLowerCase();
      option.textContent = model;
      this.modelSelect.appendChild(option);
    });
  }
}

// Initialize components
document.addEventListener("DOMContentLoaded", () => {
  const sliderContainer = document.querySelector(".hero-slider");
  if (sliderContainer) {
    new HeroSlider(sliderContainer);
  }

  new VehicleFinder();
});

document.addEventListener("DOMContentLoaded", function () {
  // Get all logo sliders on the page
  const sliders = document.querySelectorAll("[data-logo-slider]");

  sliders.forEach(function (slider) {
    if (!slider) return;

    // Clone items for infinite loop
    const items = slider.children;
    const originalItemsCount = items.length;

    // Clone all items to create seamless loop
    [...items].forEach((item) => {
      const clone = item.cloneNode(true);
      slider.appendChild(clone);
    });

    let scrollInterval;
    let isScrolling = false;
    let scrollDirection = 1; // 1 for right, -1 for left

    const startAutoScroll = () => {
      if (isScrolling) return;
      isScrolling = true;

      scrollInterval = setInterval(() => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const currentScroll = slider.scrollLeft;

        // Smooth continuous scrolling without reset
        slider.scrollLeft += scrollDirection;

        // When reaching the end, smoothly reverse direction
        if (currentScroll >= maxScroll) {
          scrollDirection = -1;
        } else if (currentScroll <= 0) {
          scrollDirection = 1;
        }
      }, 30);
    };

    const stopAutoScroll = () => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
        scrollInterval = null;
      }
      isScrolling = false;
    };

    // Start auto-scroll after a short delay
    setTimeout(startAutoScroll, 1000);

    // Pause on hover or touch
    slider.addEventListener("mouseenter", stopAutoScroll);
    slider.addEventListener("mouseleave", startAutoScroll);
    slider.addEventListener("touchstart", stopAutoScroll);
    slider.addEventListener("touchend", startAutoScroll);

    // Pause on focus for accessibility
    slider.addEventListener("focusin", stopAutoScroll);
    slider.addEventListener("focusout", startAutoScroll);
  });
});  

